// Copyright (c) 2016 Deere & Company

import LaborStatsReport from './components/labor-stats-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reports.laborStats,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams, location} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName: location.pathname,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborStatsReport);



// WEBPACK FOOTER //
// ./src/reports/labor-stats/state-connector.js